import React from 'react';
import { useSelector } from 'react-redux';
import { Col, Container, Row } from '@yme/atoms/grid';
import { useWindowSize } from '@yme/common/hooks';
import { IndentWrapper } from '@yme/components/Separator';
import { CardWithButton } from '@yme/molecules/cards';
import { getRTL } from '@yme/selectors/common';
import { colorCoreBlack900Base } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { HeadingLevel2 } from '@yme/tokens/typography';
import { buildKey, getCardsColumnNumberForTablet } from '@yme/utils/common';
import { AspectRatio } from '@yme/utils/constants';
import { TEST_RIDE_DATA_ID } from './constants';
import { calcMarginBottom, getColumnNumberForDesktop } from './helpers';
export function RequestTestRide(props) {
    const { isRemoveBottomIndent, cards, header } = props;
    const isRightToLeft = useSelector(getRTL);
    const { isMobileView, isInfiniteDesktopView, isTabletView } = useWindowSize();
    const cardsLength = cards.length;
    const cardsContent = cards.map(({ backgroundImage, button }, index) => {
        const desktopColsNumber = getColumnNumberForDesktop(cardsLength);
        const tabletColsNumber = getCardsColumnNumberForTablet(cardsLength);
        const marginBottom = calcMarginBottom({
            length: cardsLength,
            isMobileView,
            isInfiniteDesktopView,
            isTabletView,
            index,
        });
        return (React.createElement(Col, { lg: desktopColsNumber, md: tabletColsNumber, key: buildKey(button.link, index) },
            React.createElement(CardWithButton, { backgroundImage: backgroundImage, button: button, marginBottom: marginBottom, isRightToLeft: isRightToLeft, aspectRatio: cardsLength === 1 ? AspectRatio.RectangleLevel2 : AspectRatio.RectangleLevel3 })));
    });
    if (cards.length === 0 || !header) {
        return null;
    }
    return (React.createElement(IndentWrapper, { isRemoveBottomIndent: isRemoveBottomIndent },
        React.createElement(Container, { dataTestId: TEST_RIDE_DATA_ID, isRightToLeft: isRightToLeft },
            React.createElement(Row, null,
                React.createElement(Col, null,
                    React.createElement(FlexWrapper, { mb: "24px", mbTablet: "24px", mbDesktop: "32px" },
                        React.createElement(HeadingLevel2, { color: colorCoreBlack900Base }, header)))),
            React.createElement(Row, null, cardsContent))));
}
RequestTestRide.displayName = 'RequestTestRide_AEMComponent';
